<template>
  <div v-if="$canAndRulesPass(user, $permissions.SETTING.UPDATE)">
    <page-heading
      heading="Настройки"
    >
      <span slot="help"></span>
      <span slot="right"></span>
    </page-heading>



    <el-card>
      <component
        :is="settingTemplate"
      ></component>
    </el-card>




  </div>
</template>

<script>
import PageHeading from "@/components/PageHeading";
import {mapGetters} from "vuex";

export default {
  name: 'DynamicSettings',
  components: {PageHeading},

  computed: {
    ...mapGetters(['user']),
    settingTemplate() {
      return this.$companyConfiguration.settings.getTemplate();
    }
  },
  data() {
    return {

    }
  },
  mounted() {},
  methods: {

  }
}

</script>


<style lang="scss">
@import "./src/assets/css/project-variables";


</style>
